// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2021-08-19 02:49:24 +0200 (Thu, 19 Aug 2021) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 120942 $
//  Purpose   : qa specific wiki elements
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import {mapItems, strip} from 'ldash'
import log from 'uix/logging'
import {Actions, Sel} from 'uix/registries'
import {TagMatcher} from 'uix/wiki/utils'

// ---Local imports

import {BasicTimeline} from './components'

// ---Exports
export const Timeline = TagMatcher(
  'Timeline',
  ({events, days, header, text}) => {
    if (text) {
      events = text
    }
    let eventType = events
      ? events
          .split(',')
          .map(e => strip(e))
          .filter(e => e)
      : events
    days = days ? parseInt(days) : days
    return <BasicTimeline eventType={eventType} days={days} header={header} />
  },
  {eventType: ['ReleaseStateChange', 'WikiChange'], days: ['7', '30'], header: ['Ereignisse']},
  'Timeline component (element text is interpreted as comma separated list of eventTypes)'
)
